import { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
// import headerImg from "../assets/img/poster.png";
import headerImg from "../assets/img/poster1.png";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import "./Style.css";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  // Typewriter
  const roles = useMemo(
    () => ["Web Developer", "Backend Developer", "Android Developer", "iOS Developer", "API Developer"],
    []
  );
  const period = 1200;

  const [loop, setLoop] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [txt, setTxt] = useState("");
  const [delta, setDelta] = useState(120);

  useEffect(() => {
    const i = loop % roles.length;
    const full = roles[i];

    const tick = () => {
      const updated = isDeleting ? full.substring(0, txt.length - 1) : full.substring(0, txt.length + 1);
      setTxt(updated);

      // speed up delete
      if (isDeleting) setDelta(60);

      if (!isDeleting && updated === full) {
        setIsDeleting(true);
        setDelta(period);
      } else if (isDeleting && updated === "") {
        setIsDeleting(false);
        setLoop(loop + 1);
        setDelta(140);
      }
    };

    const t = setTimeout(tick, delta);
    return () => clearTimeout(t);
  }, [txt, isDeleting, loop, roles, delta]);

  return (
    <section className="banner" id="home" aria-label="Introduction">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={7} xl={7}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <div className="eyebrow">
                    <Badge bg="info" className="me-2">Lead Flutter Dev</Badge>
                    <Badge bg="info" className="me-2">Web Frontend</Badge>
                    <Badge bg="info" className="me-2">Backend Developer</Badge>
                    <Badge bg="dark">Founder @ BrainToDo</Badge>
                  </div>

                  <h2 className="title-label mt-3">
                    Hi, I’m <span className="highlight">Mir Fahim Rahman</span>
                    <span className="roleline">
                      — <span className="cursor-wrap">{txt}<span className="cursor">|</span></span>
                    </span>
                  </h2>

                  <p className="lead mt-3">
                    I build real apps that work. <strong>7+</strong>  years creating cross-platform apps and backend systems that move money and drive results.
<strong> 15+</strong> apps launched in the market, 40+ app contributions, and real business software actively running. </p>
<p>I’m the founder & creator of{" "}
  <a className="inline-link" href="https://braintodo.com" target="_blank" rel="noopener noreferrer">
                      BrainToDo (CRM + HRM)
                    </a>
                    , where I architected the platform end-to-end: frontend, backend, auth, automations—the whole stack.
</p>
                  <p className="subtext">
                    Recent work: PayPlus Agent—handles <strong>a large amount of transactions per day</strong> in recharge & payments.
                    Expert with Flutter (BLoC, Provider, GetX), Firebase, REST, push/local notifications, and
                    Worked with Flutter since the <strong>alpha stage(2018)</strong>. Also build Laravel APIs for several projects and React websites.
                  </p>

                  <div className="metrics">
                    <div className="chip">7+ yrs</div>
                    <div className="chip">15+ apps shipped</div>
                    <div className="chip">50+ app contributions</div>
                    <div className="chip">200+ APIs</div>
                    <div className="chip">Several Websites build</div>
                  </div>

                  <div className="cta-group">
                    <a href="#projects" className="btn-cta">
                      Explore my projects <ArrowRightCircle size={22} />
                    </a>
                    <a href="https://github.com/MIR-FAHIM" target="_blank" rel="noopener noreferrer" className="btn-ghost">Github</a>
                    <a href="#connect" className="btn-ghost">Let’s build</a>
                  </div>
                </div>
              )}
            </TrackVisibility>

            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn animate__delay-1s" : ""}>
                  <div className="cred-bar">
                    <span className="dot" /> Flutter • Laravel • ReactJS • Firebase • REST
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={5} xl={5} className="mt-4 mt-md-0">
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <div className="image-wrap">
                    <img src={headerImg} alt="Product & code collage" className="hero-img" />
                    <div className="img-glow" aria-hidden />
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      <div className="resume-banner">
        <Container>
          <Row>
            <Col>
              <div className="resume-card">
                <span className="resume-badge">Resume Summary</span>
                <p className="resume-text">
                  <span className="resume-highlight">Mir Fahim</span> is a full stack developer with{" "}
                  <span className="resume-highlight">7+ years</span> of experience. Main expertise in{" "}
                  <span className="resume-highlight">Flutter app development</span>,{" "}
                  <span className="resume-highlight">Laravel APIs</span>, and{" "}
                  <span className="resume-highlight">React web apps</span>. Currently working at the fintech company{" "}
                  <span className="resume-highlight">PayStation</span> as Lead App Developer.
                  <span className="resume-highlight">He </span> is capable to develop your Android and iOS Applications, Websites and Web Applications, Your backend technologies and server management.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};
